module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/my-settings/bank-accounts/add-bank-account/add-bank-account.component.scss
// module id = ./src/app/pages/client/my-settings/bank-accounts/add-bank-account/add-bank-account.component.scss
// module chunks = main